import React from 'react';

class ModalFullScreen extends React.Component
{
    componentDidMount(){
        document.addEventListener('mousedown',this.handleCLickOutside)
    }

    componentWillUnmount(){
        document.addEventListener('mousedown', this.handleCLickOutside)
    }


    handleCLickOutside = (e) => {
        this.props.closeModalFromChild(false);
    }

    render(){
        return(
            <div id="myModal" className="GNP-modal-full-screen">
                <div className="GNP-modal-content-full-screen">
                    <div className="GNP-modal-body-full-screen">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalFullScreen;


// WEBPACK FOOTER //
// ./src/generalcomponets/modal-full-screen/index.js